import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import AiModelPricing from "../domain/AiModelPricing";

class AiModelPricingService {

    readonly basePath = "/ai-model-pricings";

    public add(pricing: AiModelPricing): Promise<string> {
        return Axios.post(`${this.basePath}`, pricing).then(value => value.data.id);
    }

    public update(id: string, pricing: AiModelPricing): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, pricing);
    }

    public get(id: string): Promise<AiModelPricing> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => AiModelPricing.fromPOJO(value.data));
    }

    public delete(pricing: AiModelPricing): Promise<void> {
        return Axios.delete(`${this.basePath}/${pricing.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<AiModelPricing>> {
        return Axios.get(`${this.basePath}?${queryOptions.toQueryParams()}`)
            .then(value => {
                const objectList: AiModelPricing[] = [];

                value.data.data.forEach((objectJson: object) => {
                    objectList.push(AiModelPricing.fromPOJO(objectJson));
                });

                return new PagedResult(value.data.total, objectList);
            });
    }
}

export default AiModelPricingService;
